<span class="public-pr">Procurement made </span>
<span id="public-textslide" class="public-text">{{ text}}</span>
<span class="public-typed-cursor">|</span>
